export const isOwnDomainEmail = (email, ownDomainSet) => {
    if (!email) {
        return true;
    }
    const at = email.indexOf('@');
    if (at < 0 || at === email.length - 1) {
        return false;
    }
    return ownDomainSet.has(email.slice(at + 1));
};
